import { render, staticRenderFns } from "./SalaryStructure.vue?vue&type=template&id=3b468d40&scoped=true&"
import script from "./SalaryStructure.vue?vue&type=script&lang=js&"
export * from "./SalaryStructure.vue?vue&type=script&lang=js&"
import style0 from "./SalaryStructure.vue?vue&type=style&index=0&id=3b468d40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b468d40",
  null
  
)

export default component.exports